import React, { useState } from 'react';
import { WAREHOUSES } from './config/warehouseConfig';
import LayoutSelector from './components/LayoutSelector';
import StorageSelector, { LocationDetail } from './components/StorageSelector';
import './App.css';

const App = () => {
  const [warehouseId, setWarehouseId] = useState(WAREHOUSES[0].id);
  const [selection, setSelection] = useState(null); // rack / aisle
  const [location, setLocation] = useState(null); // shelf / slot / floor slot
  const warehouse = WAREHOUSES.find((w) => w.id === warehouseId);

  const changeWarehouse = (id) => {
    setWarehouseId(id);
    setSelection(null);
    setLocation(null);
  };

  return (
    <div className="app">

      <h2 style={{marginTop: 5, marginBottom: 15}}>Brosline Warehouse Management</h2> 

      <div className="tabs">
              {WAREHOUSES.map((w) => (
                <button
                  key={w.id}
                  type="button"
                  className={`tab${w.id === warehouseId ? ' active' : ''}`}
                  onClick={() => changeWarehouse(w.id)}
                >
                  {w.name}
                </button>
              ))}
          </div>

      <div className='row'>


        <div className='col-md-6'>
         

          <section className="panel">
            <h2>1. Rack / Aisle</h2>
            <LayoutSelector
              warehouse={warehouse}
              selection={selection}
              onSelect={(s) => {
                setSelection(s);
                setLocation(null);
              }}
            />
          </section>
        </div>

        <div className='col-md-6'>
          <section className="panel">
            <h2>2. Shelf / Slot / Floor Slot</h2>
            <div style={{display: "flex", gap: "15px"}}>
              <StorageSelector
                warehouse={warehouse}
                selection={selection}
                location={location}
                onSelectLocation={setLocation}
              />
            </div>

            <div style={{marginTop: 20}}>
            <LocationDetail location={location} />
            </div>  

          </section>
        </div>
      </div>
    </div>
  );
};

export default App;
